import React from "react";
import { useNavigate } from "react-router-dom";
import ReferralModal from "./ReferralModal";

type ReferralModalPageProps = {
  fullPage?: boolean;
};

const ReferralModalPage: React.FC<ReferralModalPageProps> = ({
  fullPage = false,
}) => {
  const navigate = useNavigate();

  const handleClose = () => {
    if (fullPage) {
      navigate("/");
    } else {
      navigate(-1);
    }
  };

  return (
    <ReferralModal open={true} handleClose={handleClose} fullPage={fullPage} />
  );
};

export default ReferralModalPage;
